import { SetStateAction } from "react";
import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";

export const exportStaModal = ({
  t,
  startImportSta,
  startExportSta,
  windowValues,
  setWindowValues,
  closeMsg,
}: stdObject) => {
  return "exportStaList" in windowValues
    ? {
        title: t(`p.${windowValues.type}`),
        inputs: windowValues.exportStaList.map(
          (e: stdObject, index: number) => {
            return {
              label: e.NOMDOC,
              value: e.value ? 1 : 0,
              type: "checkbox",
              style: { width: 300 },
              onChange: (v: { target: { value: SetStateAction<string> } }) => {
                let tempValues = windowValues.exportStaList;
                tempValues[index].value = Number(v.target.value) ? 0 : 1;
                setWindowValues({
                  ...windowValues,
                  exportStaList: tempValues,
                });
              },
            };
          },
        ),
        buttons: [
          {
            label: t(`p.${windowValues.type}`),
            onClick:
              windowValues.type === "import" ? startImportSta : startExportSta,
            color:
              windowValues.type === "import" ? colors.green : colors.orange,
          },
          {
            label: t("p.cancel"),
            onClick: closeMsg,
            color: colors.darkGrey,
          },
        ],
      }
    : {};
};
